import React from "react";
import { ObjectFieldDataTypes } from "../constants/ObjectFieldDataTypes";
import { ObjectField } from "../models/ObjectField";
import { Tooltip } from "../primereact";
import moment from "moment";

export class ObjectFieldValueElement {

    private static ObjectField = new ObjectField();
    private static EntityObject = {};
    private static ValueStyles = {};

    static build(objectField: ObjectField, entityObject: any, valueStyles: any = {}): JSX.Element | null {

        if (objectField === null || objectField === undefined || entityObject === null || entityObject === undefined) {
            return null;
        }

        this.ObjectField = objectField;
        this.EntityObject = entityObject;
        this.ValueStyles = valueStyles;

        switch (objectField.DataTypeCode.toLowerCase()) {

            case ObjectFieldDataTypes.String.toLowerCase():
            case ObjectFieldDataTypes.Text.toLowerCase():
                return this.buildStringValueElement();

            case ObjectFieldDataTypes.Boolean.toLowerCase():
                return this.buildBooleanValueElement();

            case ObjectFieldDataTypes.Date.toLowerCase():
            case ObjectFieldDataTypes.DateTime.toLowerCase():
                return this.buildDateValueElement();

            default:
                return this.buildDefaultValueElement();
        }
    }

    private static buildStringValueElement(): JSX.Element {

        let value = this.EntityObject[this.ObjectField.Code];

        switch (this.ObjectField.ValueFormatCode?.toLowerCase()) {

            case "LSBC".toLowerCase():
                let trimmedValue = value ? value.trim() : "-";
                let valueWithoutLastComma = trimmedValue.endsWith(",") ? trimmedValue.slice(0, -1) : trimmedValue;
                let isValueIncludesComma = valueWithoutLastComma.includes(",");
                return <React.Fragment>
                    {isValueIncludesComma &&
                        <Tooltip target={".ObjectFieldValueElement_" + this.ObjectField.Id} position="top" mouseTrack mouseTrackTop={15}>
                            {valueWithoutLastComma}
                        </Tooltip>
                    }
                    <span id={this.ObjectField.Code + "_Value"} className={isValueIncludesComma ? "ObjectFieldValueElement_" + this.ObjectField.Id : ""}
                        style={this.ValueStyles}>{valueWithoutLastComma.split(",")[0] + (isValueIncludesComma ? ", ..." : "")}</span>
                </React.Fragment>;

            default:
                return <span id={this.ObjectField.Code + "_Value"}>{value ? value : "-"}</span>;
        }
    }

    private static buildBooleanValueElement(): JSX.Element {

        let value = this.EntityObject[this.ObjectField.Code];

        switch (this.ObjectField.ValueFormatCode?.toLowerCase()) {

            case "LOIC".toLowerCase():
                return <span >{value !== null && value !== undefined ?
                    (value ? <i id={this.ObjectField.Code + "_Value"} className="pi pi-lock true-icon" style={this.ValueStyles}></i> :
                        <i id={this.ObjectField.Code + "_Value"} className="pi pi-lock-open false-icon" style={this.ValueStyles}></i>) : "-"}</span>;

            default:
                return <span id={this.ObjectField.Code + "_Value"} style={this.ValueStyles}>{value !== null && value !== undefined ? (value ? "True" : "False") : "-"}</span>;
        }
    }

    private static buildDateValueElement(): JSX.Element {
        let value = this.EntityObject[this.ObjectField.Code];

        return <span id={this.ObjectField.Code + "_Value"} style={this.ValueStyles}>{value ? moment(value).format("DD/MM/YY") : "-"}</span>;
    }

    private static buildDefaultValueElement(): JSX.Element {

        let value = this.EntityObject[this.ObjectField.Code];

        return <span id={this.ObjectField.Code + "_Value"} style={this.ValueStyles}>{value ? value.toString() : "-"}</span>;
    }

}